export default __webpack_public_path__ + "static/media/global-line.7f5e0bcd.svg";